import { toast } from './toast';

const currentURL = window.location.href;

function shareOnLinkedIn() {
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentURL)}`;
  window.open(linkedinUrl, '_blank');
}

function shareOnFacebook() {
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
  window.open(facebookUrl, '_blank');
}

function shareOnTwitter() {
  const twitterUrl = `https://x.com/intent/tweet?url=${encodeURIComponent(currentURL)}`;
  window.open(twitterUrl, '_blank');
}

function copyLink() {
  navigator.clipboard.writeText(currentURL).then(
    () => toast.success('Link copied!'),
    (err) => {
      console.error('Failed to copy: ', err);
    },
  );
}

export default function share() {
  const linkedInButtons = document.querySelectorAll('.share-linkedin');
  linkedInButtons.forEach((button) => {
    button.addEventListener('click', shareOnLinkedIn);
  });

  const facebookButtons = document.querySelectorAll('.share-facebook');
  facebookButtons.forEach((button) => {
    button.addEventListener('click', shareOnFacebook);
  });

  const twitterButtons = document.querySelectorAll('.share-twitter');
  twitterButtons.forEach((button) => {
    button.addEventListener('click', shareOnTwitter);
  });

  const copyButtons = document.querySelectorAll('.copy-link');
  copyButtons.forEach((button) => {
    button.addEventListener('click', copyLink);
  });
}
